import { useShopperContext } from '@salesforce/commerce-sdk-react/hooks/ShopperContexts';
import type { ShopperContextsTypes } from 'commerce-sdk-isomorphic';
import { useSSRPreviewMode } from './useSSRPreviewMode';
import { useUsidGet } from './useUsidGet';

export const useShopperContextGet = (): ShopperContextsTypes.ShopperContext | null => {
    const usidQuery = useUsidGet();
    const isSSRPreviewMode = useSSRPreviewMode();
    const { data: shopperContext } = useShopperContext(
        {
            parameters: {
                usid: usidQuery.data ?? '',
            },
        },
        {
            enabled: !!usidQuery.data && isSSRPreviewMode,
            keepPreviousData: true,
            staleTime: Infinity,
        },
    );
    return shopperContext ?? null;
};
